module.exports = __webpack_public_path__ + "img/1557923421.a66fa84c.jpg";